// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--z1RwI","item":"a10a3f92e9--item--E1gcC","title":"a10a3f92e9--title--QSQ4B","faq":"a10a3f92e9--faq--Xy5MX"};